import type { TPaddingObjectFilterCriteria } from '@timeedit/types';
import { Icon, type TEIOption, TEInput } from '@timeedit/ui-components';

type Props = {
  index: number;
  impactedObject: TPaddingObjectFilterCriteria & { impacted?: boolean };
  typeOptions: TEIOption[];
  onCriteriaUpdated: (index: number, criteria: any) => void;
  showImpact: boolean;
  onDelete?: () => void;
};

const ObjectTypeSelect = ({
  index,
  impactedObject,
  typeOptions,
  onCriteriaUpdated,
  showImpact,
  onDelete,
}: Props) => {
  return (
    <div className="field-value">
      <TEInput.Select
        data-testid={`object-type-${index}`}
        label="Object type"
        value={
          impactedObject.typeId ? impactedObject.typeId?.toString() : undefined
        }
        options={typeOptions}
        onChange={(val) =>
          onCriteriaUpdated(index, {
            typeId: Number(val),
          })
        }
        placeholder="Select"
      />
      <div className="wrapper">
        {showImpact && (
          <TEInput.Switch
            checked={impactedObject.impacted}
            onChange={(val) => {
              onCriteriaUpdated(index, { impacted: val });
            }}
            label="Impacted"
          />
        )}
        {onDelete && (
          <Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />
        )}
      </div>
    </div>
  );
};

export default ObjectTypeSelect;
